import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './promotional-banner.component.scss';
import Slider from '../slider/slider.component';
var PromotionalBanner = /** @class */ (function (_super) {
    tslib_1.__extends(PromotionalBanner, _super);
    function PromotionalBanner(element) {
        return _super.call(this, element) || this;
    }
    PromotionalBanner.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    PromotionalBanner.prototype.bindEvents = function () { };
    return PromotionalBanner;
}(Base));
export { PromotionalBanner };



//////////////////
// WEBPACK FOOTER
// ./components/promotional-banner/promotional-banner.component.ts
// module id = 468
// module chunks = 0